//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { VDialog } from "vuetify/lib";
import NavigationMenu from "@/components/positioned/NavigationMenu.vue";
import IconCompass from "@/assets/icons/nookphone/compass.svg?inline";

export default {
  data: function () {
    return {
      open: false,
    };
  },
  components: {
    VDialog,
    NavigationMenu,
    IconCompass,
  },
};
